import { IconButton } from "@mui/material";
import Iconify from "../../../minimals/components/iconify";

const RemovalRequestPendingIconButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton onClick={onClick}>
      <span style={{ position: "relative", display: "inline-block", width: 24, height: 24 }}>
        <Iconify icon="eva:trash-2-outline" width={24} height={24} style={{ color: "#BDBDBD" }} />
        <Iconify
          icon="mdi:clock-outline"
          width={16}
          height={16}
          style={{
            position: "absolute",
            top: -2,
            right: -2,
            color: "black"
          }}
        />
      </span>
    </IconButton>
  );
};

export default RemovalRequestPendingIconButton;
